import dayjs from "dayjs";
import {VehicleFilterFormValuesPaginated } from "features/log/components/Top-bar/type";
import { MatrialFilterFormValuesPaginated } from "features/master/components/master-filter-form";
import { UpLoadingLogTable } from "features/unloading-log/component/table/Uploading-Item";
import { UpLoadingFilterFormValuesPaginated } from "features/unloading-log/component/top-bar/type";
import { UpLoadingLogViewTopBar } from "features/unloading-log/component/top-bar/UpLoadingView-top-bar";
import { useGetUpLoadingList } from "features/unloading-log/use-cases/get-getUpLoading";
import { usePaginationParams } from "hooks";
import { omit } from "lodash";
import { useState } from "react";
import { formatDate } from "utils/date";

export const UnloadingLog = () => {
  const getInitialFilterValues: any = {
    date: [undefined, undefined],
    DriverName: undefined,
    SupplierName: undefined,
    VNumber: undefined,
  };
  const [showAppUserModal, setShowAppUserModal] = useState(false);
  const { params, updateParams, resetPage } =
    usePaginationParams<VehicleFilterFormValuesPaginated>({
      page: 1,
      size: 10,
      ...getInitialFilterValues,
    });
  const preparePayload = (paramsdata: MatrialFilterFormValuesPaginated) => {
    const UnloadingStartDate = paramsdata.date?.[0];
    const UnloadingEndDate = paramsdata.date?.[1];

    return {
      ...omit(paramsdata, ['date']),
      EntryTypeId:2,
      UnloadingStartDate: UnloadingStartDate
        ? formatDate({
          date: dayjs(UnloadingStartDate).startOf('day'),
          format: 'dbDate',
        })
        : undefined,
      UnloadingEndDate: UnloadingEndDate
        ? formatDate({
          date: dayjs(UnloadingEndDate).endOf('day'),
          format: 'dbDate',
        })
        : undefined,
    };
  };
  const getvehcListQueryResponse: any = useGetUpLoadingList(preparePayload(params as any), {
    retry: false,
  });

  const handleFiltersChange = (values: UpLoadingFilterFormValuesPaginated) => {
    updateParams(values);
    resetPage();
  };

  return (
    <>
      <UpLoadingLogViewTopBar
        getInitialFilterValues={getInitialFilterValues as any}
        handleFilter={handleFiltersChange}
        showAppUserModal={showAppUserModal}
        setShowAppUserModal={setShowAppUserModal}
        onRefresh={getvehcListQueryResponse.refetch}
      />
      <UpLoadingLogTable
        isListUpLoading={
          getvehcListQueryResponse.isFetching
        }
        UploadingList={getvehcListQueryResponse?.data?.res?.items}
        itemsCount={getvehcListQueryResponse.data?.totalRecords || 0}
        tableParams={params as any}
        updateParams={updateParams}
        onRefresh={getvehcListQueryResponse.refetch}
        isFetching={ getvehcListQueryResponse.isFetching}
      />
    </>
  );
};
